import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCategories, deleteCategory } from '../../services/categoryService';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Typography, Select, MenuItem
} from '@mui/material';
import { useGroupContext } from '../Groups/useGroupContext';


const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryType, setSelectedCategoryType] = useState('ALL');
  const navigate = useNavigate();
  const { getContextParams } = useGroupContext();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const contextParams = getContextParams();
        const data = await getCategories(contextParams);
        setCategories(data);
      } catch (error) {
        console.error(error);
        alert('Error fetching categories');
      }
    };

    fetchCategories();
  }, [getContextParams]);

  const handleDelete = async (id) => {
    try {
      const contextParams = getContextParams();
      await deleteCategory(id, contextParams);
      setCategories(categories.filter((category) => category.id !== id));
      alert('Category deleted.');
    } catch (error) {
      console.error(error);
      alert('Failed to delete category.');
    }
  };

  const handleCategoryChange = (e) => {
    setSelectedCategoryType(e.target.value);
  };

  const filteredCategories =
    selectedCategoryType === 'ALL'
      ? categories
      : categories.filter((category) => category.type === selectedCategoryType);

  return (
    <TableContainer component={Paper} sx={{ maxWidth: '60%', margin: 'auto', mt: 3 }}>
  <Typography variant="h5" sx={{ textAlign: 'center', mb: 2 }}>Your Categories</Typography>

  <Select value={selectedCategoryType} onChange={handleCategoryChange} sx={{ width:'150px',mb: 2, ml: 1, height: '40px' }}>
    <MenuItem value="ALL">All</MenuItem>
    <MenuItem value="EXPENSE">Expense</MenuItem>
    <MenuItem value="INCOME">Income</MenuItem>
    <MenuItem value="INVESTMENT">Investment</MenuItem>
  </Select>

  <Table>
    <TableHead>
      <TableRow>
        <TableCell><strong>Name</strong></TableCell>
        <TableCell><strong>Type</strong></TableCell>
        <TableCell><strong>Actions</strong></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {filteredCategories.map((category) => (
        <TableRow key={category.id}>
          <TableCell sx={{ padding: '4px 8px' }}>{category.name}</TableCell>
          <TableCell sx={{ padding: '4px 8px' }}>{category.type}</TableCell>
          <TableCell sx={{ padding: '4px 8px' }}>
            <Button variant="contained" color="primary" sx={{ height: '25px' }} onClick={() => navigate(`/edit-category/${category.id}`)}>Edit</Button>
            <Button variant="contained" color="error" sx={{ height: '25px', ml: 1 }} onClick={() => handleDelete(category.id)}>Delete</Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
  );
};

export default Categories;
